/**
 * FormTypeEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { FormTypeVersionEntity } from "../FormTypeVersionEntity";
import { FormTypeEntity } from "../FormTypeEntity";
declare global {
    interface EntityTypeMap {
        FormType: FormTypeEntity;
    }
}
export abstract class FormTypeGeneratedEntity extends BaseEntity {
    public abstract formTypeId: string;
    public abstract templateId: string | null;
    public abstract name: string;
    public abstract containsConformityWithObservation: boolean | null;
    public abstract hidden: boolean | null;
    public abstract project: ProjectEntity;
    public abstract readonly versions: ReadonlyArray<FormTypeVersionEntity>;
    public abstract activeVersion: FormTypeVersionEntity | null;
}
